import React, { useState } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useHistory } from "react-router-dom";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from '../../../utilities/TableUtil';
import { normalColumn, actionEditColumn } from '../../../components/DataTable/DataTable.js';
import * as bodyStyle from '../../../components/DataTable/ConsBodyStyle.js';
import { InputText } from 'primereact/inputtext';


export default function P221List({ dataTable  }) {

    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    
    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows} 
                    onPage={(e)=>onPageChange(e,setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    // globalFilter={globalFilter}
                    emptyMessage="ไม่พบข้อมูลที่ค้นหา"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >

                    <Column sortable field="seq" header="ครั้งที่" body={(e) => normalColumn(e, 'seq', 'ครั้งที่')} style={{textAlign: 'center',width: '8%' }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="deliverAmount" header="จำนวนเงินรวมที่ส่งมอบงาน" body={(e) => normalColumn(e, 'deliverAmount', 'จำนวนเงินรวมที่ส่งมอบงาน')} style={{ textAlign: 'center',width: '15%'}}  bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column sortable field="letterNo" header="หนังสือส่งมอบงานเลขที่"  body={(e) => normalColumn(e, 'letterNo', 'หนังสือส่งมอบงานเลขที่')} style={{ textAlign: 'center', width: '15%' }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column sortable field="letterDate" header="ลงวันที่"  body={(e) => normalColumn(e, 'letterDate', 'ลงวันที่')} style={{ textAlign: 'center', width: '15%' }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column sortable field="deliverMeetingDate" header="ตรวจรับวันที่"  body={(e) => normalColumn(e, 'deliverMeetingDate', 'ตรวจรับวันที่')} style={{ textAlign: 'center', width: '15%' }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column field="remark" header="หมายเหตุ"  body={(e) => normalColumn(e, 'remark', 'หมายเหตุ')} style={{ textAlign: 'center'}} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    
                </DataTable>
            </div>
        </div>
    )
}
